import { KYMW9005Component } from './kymw9005.component';

/**
 * ユーザ情報詳細画面の値を管理するクラス
 *
 * @export KYMW9005Model
 * @class KYMW9005Model
 */
export class KYMW9005Model {

  kymw9005Component: KYMW9005Component;

  public authoritySetList: Array<any> = new Array<any>();
  public associatedUserTypeList: Array<any> = new Array<any>();

  /**
   * ユーザID
   */
  public associatedUserId: string = <string>'';
  /**
   * ユーザ区分(1　取引先(卸)、2　スタジオ、3　制作会社）
   */
  public associatedUserType: string = <string>'';
  /**
   * ユーザ区分名
   */
  public associatedUserTypeName: string = <string>'';
  /**
   * 氏名
   */
  public associatedUserName: string = <string>'';
  /**
   * 氏名（かな）
   */
  public associatedUserNameKana: string = <string>'';
  /**
   * メールアドレス
   */
  public emailAddress: string = <string>'';
  /**
   * 権限セットID
   */
  public authoritySetId: string = <string>'';
  /**
   * 権限セット名
   */
  public authoritySetName: string = <string>'';
  /**
   * 関連会社ID
   */
  public associatedCompanyId: string = <string>'';
  /**
   * 関連会社名（所属会社名）
   */
  public associatedCompanyName: string = <string>'';
  /**
   * 有効無効区分（0:有効、1:無効）
   * // 初期値 0:有効
   */
  public isEnabled: string = <string>'0';

  /**
   * 編集フラグ
   */
  public isEdited: boolean = <boolean>false;

  /**
   * 関連会社情報取得API成功処理
   */
  public updateUserInformationDeatil(serverData: any): void {
    this.associatedUserId = serverData.AssociatedUserId;
    this.associatedUserType = serverData.AssociatedUserType;
    this.associatedUserName = serverData.AssociatedUserName;
    this.associatedUserNameKana = serverData.AssociatedUserNameKana;
    this.emailAddress = serverData.EmailAddress;
    this.authoritySetId = serverData.AuthoritySetId;
    this.authoritySetName = serverData.AuthoritySetName;
    this.associatedCompanyId = serverData.AssociatedCompanyId;
    this.associatedCompanyName = serverData.AssociatedCompanyName;
    this.isEnabled = serverData.IsEnabled;
  }
}
